import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON008_Request,
  IAPI_CON008_Response,
} from "../../../type/apiType";

// 退職手当共済契約解除参照
const httpAPI_CON008 = async (
  param: IAPI_CON008_Request
): Promise<IAPI_CON008_Response> => {
  let res = await http.post(ApiUrl.API_CON008, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON008, httpAPI_APP016 };
